import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import SelectOrApplyButton from '../SelectOrApplyButton'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const BOTCareerDescriptionTeaser = ({ content, ...props }) =>
  <Wrapper>
    <HTMLContainer content={ content } />
    <ApplyButtonWrapper>
      <SelectOrApplyButton { ...props } />
    </ApplyButtonWrapper>
  </Wrapper>

BOTCareerDescriptionTeaser.propTypes = {
  content: PropTypes.string
}

export default BOTCareerDescriptionTeaser

const Wrapper = styled.div`
  margin: 5%;
  padding: 50px 60px;
  background-color: white;
  ${Media.mobile`
    margin: 10% 5%;
    padding: 20px;
    text-align: center;
  `}
`

const ApplyButtonWrapper = styled.div`
  ${Media.desktop`
    margin-top: -20px;
  `}
  ${Media.mobile`
    margin: 30px 0 10px;
  `}
`
